import { render, staticRenderFns } from "./PaginaDatosPersona.vue?vue&type=template&id=42c55865&scoped=true&"
import script from "./PaginaDatosPersona.vue?vue&type=script&lang=js&"
export * from "./PaginaDatosPersona.vue?vue&type=script&lang=js&"
import style0 from "./PaginaDatosPersona.vue?vue&type=style&index=0&id=42c55865&lang=scss&scoped=true&"
import style1 from "./PaginaDatosPersona.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c55865",
  null
  
)

export default component.exports